/* begin general import */
import { openOnRowClick } from "helpers/row-click";
import React, { useMemo } from "react";
import { Menu, Dropdown, Card } from "antd";
import Table, { ColumnProps } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import masterService from "services/pages/master-service";
import nameof from "ts-nameof.macro";
import InputSearch from "components/Utility/InputSearch/InputSearch";
import Pagination from "components/Utility/Pagination/Pagination";
import classNames from "classnames";
import { deviceTypeRepository } from "repositories/device-type-repository";
import { DeviceType, DeviceTypeFilter } from "models/DeviceType";
import { DEVICE_TYPE_ROUTE } from "config/route-consts";

function DeviceTypeMaster() {
  const [translate] = useTranslation();
  const {
    list,
    total,
    loadingList,
    filter,
    handleUpdateNewFilter,
    handleGoDeviceTypeDetail,
    handleTableChange,
    handlePagination,
  } = masterService.useMaster<DeviceType, DeviceTypeFilter>(
    DeviceTypeFilter,
    DEVICE_TYPE_ROUTE,
    deviceTypeRepository.list,
    deviceTypeRepository.count
  );

  const _handleChangeFilter = React.useCallback(
    (value) => {
      const newFilter = { ...filter };
      newFilter["search"] = value;
      handleUpdateNewFilter(newFilter);
    },
    [filter, handleUpdateNewFilter]
  );

  const menuAction = React.useCallback(
    (id: number) => (
      <Menu>
        <Menu.Item key="1">
          <div
            className="ant-action-menu"
            onClick={handleGoDeviceTypeDetail(id)}
          >
            {translate("general.actions.view")}
          </div>
        </Menu.Item>
      </Menu>
    ),
    [handleGoDeviceTypeDetail, translate]
  );

  const columns: ColumnProps<DeviceType>[] = useMemo(
    () => [
      {
        title: (
          <div className="gradient-text">{translate("Loại thiết bị")}</div>
        ),
        key: "1",
        dataIndex: "name",
        sorter: false,
        align: "left",
        width: 400,
        render(name: string) {
          return (
            <div className="ant-cell-master__container">
              <div
                className={classNames(
                  "cell-master__first-row",
                  "first-row--link"
                )}
              >
                {name}
              </div>
            </div>
          );
        },
      },
      {
        title: (
          <div className="text-center gradient-text">
            {translate("Số lượng")}
          </div>
        ),
        key: "2",
        dataIndex: "quantity",
        sorter: true,
        width: 150,
        render(quantity: number) {
          return (
            <div className="ant-cell-master__container">
              <div
                className={classNames(
                  "cell-master__first-row",
                  "first-row--link"
                )}
              >
                {quantity}
              </div>
            </div>
          );
        },
      },

      {
        title: (
          <div className="text-center gradient-text">
            {translate("general.actions.action")}
          </div>
        ),
        key: "action",
        dataIndex: nameof(list[0].id),
        fixed: "right",
        width: 100,
        align: "center",
        render(id: number) {
          return (
            <div className="d-flex justify-content-center button-action-table">
              <Dropdown
                overlay={menuAction(id)}
                trigger={["click"]}
                placement="bottomCenter"
                arrow
              >
                <span className="action__dots">...</span>
              </Dropdown>
            </div>
          );
        },
      },
    ],
    [translate, list, menuAction]
  );

  return (
    <>
      <div className="page page__master device__container">
        <div className="page__header d-flex align-items-center justify-content-between">
          <div className="page__title">
            {translate("deviceTypes.master.title")}
          </div>
        </div>
        <div className="page__search">
          <Card bordered={false}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex w-50">
                <div className="w70">
                  <InputSearch
                    value={filter["search"]}
                    onChange={_handleChangeFilter}
                    placeHolder="Tìm kiếm"
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="page__master-table custom-scrollbar pb-4">
          <Card bordered={false}>
            <Table
              onRow={(record) => openOnRowClick(handleGoDeviceTypeDetail(record.id))}
              rowKey={nameof(list[0].id)}
              columns={columns}
              pagination={false}
              dataSource={list}
              loading={loadingList}
              onChange={handleTableChange}
              scroll={{ x: "max-content" }}
              title={() => (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="action__result">{total} Kết quả</span>
                    <div className="flex-shrink-1 d-flex align-items-center">
                      <Pagination
                        skip={filter.skip}
                        take={filter.take}
                        total={total}
                        onChange={handlePagination}
                        style={{ margin: "10px" }}
                      />
                    </div>
                  </div>
                </>
              )}
            />
          </Card>
        </div>
      </div>
    </>
  );
}

export default DeviceTypeMaster;
